module.exports = __webpack_public_path__ + "static/media/head-in-the-sand.93f7df5f.png";